const setLastActive = (id) => {
  window.debug.log('Setting last active');
  return `
      mutation {
        setLastActive (
          applicantId: "${id}"
        )
      }
    `;
};

function details(fields, id) {
  return `mutation {
  putDetails(
    swapDate: ${toGraphQlString(fields.swapDate)}
    applicantId: "${id}"
    ${getDetailFields(fields, 1)}
    ${getDetailFields(fields, 2)}  
  ) {
    swapDate
    details1 {
      personCount
      childrenCount
      moveToApartment
    }
    details2 {
      personCount
      childrenCount
      moveToApartment
    }
  }
}`;
}

function members(fields, id, index) {
  const signLink = fields.signLink && `signLink: "${fields.signLink}"`;
  return `
  mutation  {
    putMember ( member: {
      applicantId: "${id}"
      index: ${index === 1 ? 'ONE' : 'TWO'}
      name: ${toGraphQlString(fields.name)}
      ssn: ${toGraphQlString(fields.ssn)}
      phone: ${toGraphQlString(fields.phone)}
      email: ${toGraphQlString(fields.email)}
      registeredAddress: ${toGraphQlString(fields.registeredAddress)}
      registeredPostalCode: ${toGraphQlString(fields.registeredPostalCode)}
      registeredCity: ${toGraphQlString(fields.registeredCity)}
      onCurrentContract: ${toGraphQlBoolean(fields.onCurrentContract)}
      hasOtherApartment: ${toGraphQlBoolean(fields.hasOtherApartment)}
      otherApartmentInfo: ${toGraphQlString(
        fields.otherApartmentInfo || { value: null }
      )}
      ${signLink || ''}

    }) {
      name
      ssn
      phone
      email
      registeredAddress
      registeredPostalCode
      registeredCity
      onCurrentContract
      hasOtherApartment
      otherApartmentInfo
    }
  }`;
}

function apartments(fields, id, index) {
  return `
  mutation  {
    putApartment ( apartment: {
      applicantId: "${id}"
      index: ${index === 1 ? 'ONE' : 'TWO'}
      address: ${toGraphQlString(fields.address)}
      postalCode: ${toGraphQlString(fields.postalCode)}
      city: ${toGraphQlString(fields.city)}
      landlord: ${toGraphQlString(fields.landlord)}
      landlordAddress: ${toGraphQlString(fields.landlordAddress)}
      apartmentNumber: ${toGraphQlString(fields.apartmentNumber)}
      objectNumber: ${toGraphQlString(fields.objectNumber)}   
      rooms: ${toGraphQlInt(fields.rooms)}
      area: ${toGraphQlInt(fields.area)}
      rent: ${toGraphQlInt(fields.rent)}
      hadSince: ${toGraphQlString(fields.hadSince)}
      landlordPhone: ${toGraphQlString(fields.landlordPhone)}
      landlordEmail: ${toGraphQlString(fields.landlordEmail)}
      ${
        fields.adultCount
          ? `adultCount: ${toGraphQlInt(fields.adultCount)}`
          : ''
      }
      ${
        fields.childrenCount
          ? `childrenCount: ${toGraphQlInt(fields.childrenCount)}`
          : ''
      }
    }){
      address
      apartmentNumber
      ${getApprovalStatus()}
      area
      city
      hadSince
      landlord
      landlordAddress
      landlordEmail
      landlordPhone
      objectNumber
      postalCode
      rent 
      rooms
    }
  }
  `;
}

function swapReason(fields, id) {
  return `
    mutation {
      putSwapReason(swapReason: {
        applicantId: "${id}"
        freeText: ${JSON.stringify(fields.freeText.value)}
      }) {
        freeText
        ${getApprovalStatus()}
      }
    }
    `;
}

const startApplicantMutation = (id) => `
  mutation {
    startApplicant(id: "${id}")
  }
`;

const cancelApplication = (id) => {
  window.debug.log('Cancelling applicaion');
  return `
    mutation {
      inactivateApplication ( applicantId: "${id}" )
    }
  `;
};

const reactivateApplication = (id) => {
  window.debug.log('Reactivating application');
  return `
    mutation {
      reactivateApplication ( applicantId: "${id}")
    }
  `;
};

const deleteMember2 = (id) => {
  window.debug.log('Removing member 2 from ', id);
  return `
    mutation {
      deleteMember2 ( applicantId: "${id}" )
    }
  `;
};

export default {
  apartments,
  cancelApplication,
  members,
  reactivateApplication,
  setLastActive,
  startApplicantMutation,
  deleteMember2,
  details,
  swapReason,
};

function toGraphQlString({ value: string }) {
  return string ? `"${string}"` : null;
}

function toGraphQlInt({ value: int }) {
  return int || null;
}

function toGraphQlBoolean({ value: bool }) {
  return bool || false;
}

function getApprovalStatus() {
  return `
    approvalStatus {
      admin {
        name
        picture
        email
        phone
      }
      date
      type
      message
    }`;
}

function getDetailFields(fields, i) {
  const defaultValue = { value: null };
  const moveTo = getMoveTo();

  const shouldGenerateDetails2 =
    fields[`personCount${i}`] && fields[`childrenCount${i}`];
  if (!shouldGenerateDetails2) return '';

  return `
    details${i}: {
      personCount: ${toGraphQlInt(fields[`personCount${i}`] || defaultValue)}
      childrenCount: ${toGraphQlInt(
        fields[`childrenCount${i}`] || defaultValue
      )}
      moveToApartment: ${moveTo}
    }
  `;

  function getMoveTo() {
    if (!fields[`moveToApartment${i}`]) return null;
    const address = fields[`moveToApartment${i}`].value;
    if (address !== 'ONE' && address !== 'TWO') return 'ONE';
    return address;
  }
}



// WEBPACK FOOTER //
// ./src/features/Application/mutations.js